<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NKOasp/tc-custom/9781634865623.jpg?1723405692261" alt="This image is the cover for the book Hot Shots"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hot Shots
      </h1>
      <p class="bookDescription body article font2">
        <p>Since he first laid eyes on Michael Phelps as a teenager, young Beau has longed to be an Olympian; the better to sleep with as many other Olympians as possible. Too bad he's a flop at every sport he tries.<br/><br/>An offhand reference by his European mother reveals a family connection to the world of competitive shooting, and a quick -- if not wholly truthful -- email nets Beau an invitation to Luxembourg to train with Marcel, a dashing rifle champion. He jumps at the chance, and, when he learns they aren't actually related, at the champ.<br/><br/>Sparks fly, but Beau’s never exactly been what you’d call a one-man man. Will Beau’s smoldering desire for Marcel burn hot enough to keep the torch of his Olympic dreams aflame?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael P. Thomas
      </h2>
      
      <p class="authorDescription body article">Michael P. Thomas is a former flight attendant whose mid-life career change to 911 operator has shown him that the widespread fear of sharing and receiving love is a real emergency. He writes to spread love and encourage others to do likewise. And a little bit to scare the gay-haters. For more information, visit facebook.com/GoReadMichaelPThomas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e4d33794